module.exports = __webpack_public_path__ + "img/Clear_Icon_Hover.37e27afa.svg";